export default {
  skills: [],
  skill: undefined,
  selectedSkills: [],
};
